<template>
  <div class="docal-container">
    <div v-if="isLoading" class="docal-loading">
      <spinner />
      <p>Loading Docal...</p>
    </div>
    <div v-else-if="errorMessage" class="docal-loading">
      <p>{{ errorMessage }}</p>
    </div>
    <iframe
      v-show="docalUrl"
      ref="docalFrame"
      class="docal-iframe"
      :src="docalUrl"
      frameborder="0"
      allowfullscreen
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Spinner from 'shared/components/Spinner.vue';
import DocalAPI from '../../../api/docal';

export default {
  name: 'DocalHome',
  components: {
    Spinner,
  },
  data() {
    return {
      docalUrl: '',
      isLoading: false,
      errorMessage: '',
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
    }),
  },
  mounted() {
    this.fetchDocalUrl();
  },
  methods: {
    async fetchDocalUrl() {
      this.isLoading = true;
      this.errorMessage = '';
      try {
        const response = await DocalAPI.getUrl(this.accountId);
        this.docalUrl = response.data.login_url;
      } catch (error) {
        console.error(error);
        this.errorMessage =
          error?.response?.data?.message ||
          'Failed to load Docal. Please try again.';
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.docal-container {
  display: flex;
  flex: 1;
  height: 100%;
  width: 100%;
}

.docal-iframe {
  height: 100%;
  width: 100%;
  border: 0;
}

.docal-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}
</style>
